import { JsonProperty, JsonObject } from 'json2typescript';

/**
 * @deprecated used only for vto-beauty
 *
 * Use the sku types from the new `virtual-try-on` library
 */
var PerfectCorpSkuType;
(function (PerfectCorpSkuType) {
    PerfectCorpSkuType["BLUSH"] = "Blush";
    PerfectCorpSkuType["EYE_LINER"] = "Eye Liner";
    PerfectCorpSkuType["EYE_SHADOW"] = "Eye Shadow";
    PerfectCorpSkuType["LIP_COLOR"] = "Lip Color";
    PerfectCorpSkuType["MASCARA"] = "Mascara";
    PerfectCorpSkuType["BRONZER"] = "Bronzer";
    PerfectCorpSkuType["FACE_CONTOUR"] = "Face Contour";
})(PerfectCorpSkuType || (PerfectCorpSkuType = {}));
/**
 * @deprecated used only for vto-beauty
 *
 * Use the sky types from the new `virtual-try-on` library
 */
var PerfectCorpSubSkuType;
(function (PerfectCorpSubSkuType) {
    PerfectCorpSubSkuType["HIGHLIGHT"] = "highlight";
    PerfectCorpSubSkuType["CONTOUR"] = "contour";
    PerfectCorpSubSkuType["HIGHLIGHT_CONTOUR"] = "highlight_contour";
})(PerfectCorpSubSkuType || (PerfectCorpSubSkuType = {}));

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * @deprecated used only for vto-beauty
 *
 * Use the `VtoProduct` from the new `virtual-try-on` library
 */
let VtoProduct = class VtoProduct {
    constructor() {
        this.sku = undefined;
        this.price = undefined;
        this.title = undefined;
        this.image = undefined;
        this.stock = undefined;
        this.url = undefined;
        this.variant = undefined;
        this.departmentCode = undefined;
        this.familyCode = undefined;
        this.productCode = undefined;
        this.divisionCode = undefined;
        this.size = undefined;
        this.skuType = undefined;
    }
};
__decorate([
    JsonProperty("sku", String, false),
    __metadata("design:type", String)
], VtoProduct.prototype, "sku", undefined);
__decorate([
    JsonProperty("price", Number, false),
    __metadata("design:type", Number)
], VtoProduct.prototype, "price", undefined);
__decorate([
    JsonProperty("title", String, false),
    __metadata("design:type", String)
], VtoProduct.prototype, "title", undefined);
__decorate([
    JsonProperty("image", String, false),
    __metadata("design:type", String)
], VtoProduct.prototype, "image", undefined);
__decorate([
    JsonProperty("stock", Boolean, false),
    __metadata("design:type", Boolean)
], VtoProduct.prototype, "stock", undefined);
__decorate([
    JsonProperty("url", String, false),
    __metadata("design:type", String)
], VtoProduct.prototype, "url", undefined);
__decorate([
    JsonProperty("variant", String, false),
    __metadata("design:type", String)
], VtoProduct.prototype, "variant", undefined);
__decorate([
    JsonProperty("departmentCode", String, true),
    __metadata("design:type", String)
], VtoProduct.prototype, "departmentCode", undefined);
__decorate([
    JsonProperty("familyCode", String, true),
    __metadata("design:type", String)
], VtoProduct.prototype, "familyCode", undefined);
__decorate([
    JsonProperty("productCode", String, true),
    __metadata("design:type", String)
], VtoProduct.prototype, "productCode", undefined);
__decorate([
    JsonProperty("divisionCode", String, true),
    __metadata("design:type", String)
], VtoProduct.prototype, "divisionCode", undefined);
__decorate([
    JsonProperty("size", String, true),
    __metadata("design:type", String)
], VtoProduct.prototype, "size", undefined);
__decorate([
    JsonProperty("skuType", String, true),
    __metadata("design:type", String)
], VtoProduct.prototype, "skuType", undefined);
VtoProduct = __decorate([
    JsonObject("VtoProduct")
], VtoProduct);

/**
 * @deprecated used only for vto-beauty
 *
 * Use the `VtoSubcategory` from the new `virtual-try-on` library
 */
let VtoSubcategory = class VtoSubcategory {
    constructor() {
        this.vtoSubcategoryType = undefined;
        this.vtoProducts = [];
    }
};
__decorate([
    JsonProperty("vtoSubcategoryType", String, true),
    __metadata("design:type", String)
], VtoSubcategory.prototype, "vtoSubcategoryType", undefined);
__decorate([
    JsonProperty("vtoProducts", [VtoProduct], false),
    __metadata("design:type", Array)
], VtoSubcategory.prototype, "vtoProducts", undefined);
VtoSubcategory = __decorate([
    JsonObject("VtoSubcategory")
], VtoSubcategory);

/**
 * @deprecated used only for vto-beauty
 *
 * Use the `VtoCategoryType` from the new `virtual-try-on` library
 */
var VtoCategoryType;
(function (VtoCategoryType) {
    VtoCategoryType["FACE"] = "face";
    VtoCategoryType["LIPS"] = "lips";
    VtoCategoryType["EYES"] = "eyes";
})(VtoCategoryType || (VtoCategoryType = {}));
/**
 * @deprecated used only for vto-beauty
 *
 * Use the `VtoCategory` from the new `virtual-try-on` library
 */
let VtoCategory = class VtoCategory {
    constructor() {
        this.vtoCategoryType = undefined;
        this.vtoSubcategories = [];
    }
};
__decorate([
    JsonProperty("vtoCategoryType", VtoCategoryType, false),
    __metadata("design:type", String)
], VtoCategory.prototype, "vtoCategoryType", undefined);
__decorate([
    JsonProperty("vtoSubcategories", [VtoSubcategory], false),
    __metadata("design:type", Array)
], VtoCategory.prototype, "vtoSubcategories", undefined);
VtoCategory = __decorate([
    JsonObject("VtoCategory")
], VtoCategory);

/**
 * @deprecated used only for vto-beauty
 *
 * Use the `VtoSKUResponse` from the new `virtual-try-on` library
 */
let VtoSKUResponse = class VtoSKUResponse {
    constructor() {
        this.sku = undefined;
        this.skuType = undefined;
        this.productName = undefined;
    }
};
__decorate([
    JsonProperty("sku", String, false),
    __metadata("design:type", String)
], VtoSKUResponse.prototype, "sku", undefined);
__decorate([
    JsonProperty("skuType", PerfectCorpSkuType, false),
    __metadata("design:type", String)
], VtoSKUResponse.prototype, "skuType", undefined);
__decorate([
    JsonProperty("productName", String, false),
    __metadata("design:type", String)
], VtoSKUResponse.prototype, "productName", undefined);
VtoSKUResponse = __decorate([
    JsonObject("VtoSKUResponse")
], VtoSKUResponse);

/**
 * @deprecated used only for vto-beauty
 *
 * Use the  `YmkSdkVtoConfiguration` from the new `virtual-try-on` library
 */
let YmkSdkConfiguration = class YmkSdkConfiguration {
    constructor() {
        this.apiKey = undefined;
        this.sdkPath = undefined;
    }
};
__decorate([
    JsonProperty("apiKey", String, false),
    __metadata("design:type", String)
], YmkSdkConfiguration.prototype, "apiKey", undefined);
__decorate([
    JsonProperty("sdkPath", String, false),
    __metadata("design:type", String)
], YmkSdkConfiguration.prototype, "sdkPath", undefined);
YmkSdkConfiguration = __decorate([
    JsonObject("YmkSdkConfiguration")
], YmkSdkConfiguration);

/**
 * @deprecated used only for vto-beauty
 *
 * Use the `VtoConfigurations` from the new `virtual-try-on` library
 */
let VtoConfiguration = class VtoConfiguration {
    constructor() {
        this.ymkSdkConfiguration = undefined;
        this.vtoProducts = [];
    }
};
__decorate([
    JsonProperty("ymkSdkConfiguration", YmkSdkConfiguration, false),
    __metadata("design:type", YmkSdkConfiguration)
], VtoConfiguration.prototype, "ymkSdkConfiguration", undefined);
__decorate([
    JsonProperty("vtoProducts", [VtoSKUResponse], false),
    __metadata("design:type", Array)
], VtoConfiguration.prototype, "vtoProducts", undefined);
VtoConfiguration = __decorate([
    JsonObject("VtoConfiguration")
], VtoConfiguration);

export { PerfectCorpSkuType, PerfectCorpSubSkuType, VtoCategory, VtoCategoryType, VtoConfiguration, VtoProduct, VtoSKUResponse, VtoSubcategory, YmkSdkConfiguration };
